<template>
  <div class="statistic-field-popover-content">
    <div class="header-content">
      <div
        class="header-item"
        :class="mode === 'rowMode' ? 'is-active' : modeDisabled ? 'is-disabled' : ''"
        @click="() => (modeDisabled ? '' : (mode = 'rowMode'))"
      >
        <span>分组</span>
      </div>
      <div
        class="header-item"
        :class="mode === 'statisticMode' ? 'is-active' : modeDisabled ? 'is-disabled' : ''"
        @click="() => (modeDisabled ? '' : (mode = 'statisticMode'))"
      >
        <span>统计</span>
      </div>
    </div>
    <div class="container">
      <template v-if="isRowMode">
        <component
          ref="rowFilterRef"
          is-row
          :is="`${info.fieldDetail.type}FilterOfFields`"
          :field-item="info.fieldDetail"
        />
      </template>
      <template v-else>
        <div class="empty-content" v-if="info.fieldDetail.type !== 'num'">
          <el-radio value="check" label="check">统计值</el-radio>
        </div>
        <statisticFilterOfFields v-else ref="statisticFilterRef" :item="info" />
      </template>
    </div>
  </div>
</template>

<script>
import textFilterOfFields from './textFilterOfFields';
import dateFilterOfFields from './dateFilterOfFields';
import numFilterOfFields from './numFilterOfFields';
import statisticFilterOfFields from './statisticFilterOfFields';

import { selectStatistics } from '@/constant';

export default {
  components: {
    textFilterOfFields,
    dateFilterOfFields,
    numFilterOfFields,
    statisticFilterOfFields
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    modeDisabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mode: '',
      info: null
    };
  },
  computed: {
    isRowMode() {
      return this.mode === 'rowMode';
    }
  },
  created() {
    this.mode = this.detail.mode;
    this.info = this.detail.info;
  },
  methods: {
    validateInfo() {
      const comEl = this.$refs[this.isRowMode ? 'rowFilterRef' : 'statisticFilterRef'];
      if (this.isRowMode) {
        const data = comEl ? comEl.validateInfo() : {};
        return {
          mode: this.mode,
          info: { fieldDetail: { ...this.info.fieldDetail, valueOfFilter: JSON.stringify(data) } }
        };
      } else {
        const data = comEl ? comEl.validateInfo() : { ...selectStatistics[0] };
        return {
          mode: this.mode,
          info: { fieldDetail: this.info.fieldDetail, isStatistic: true, ...data }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.statistic-field-popover-content {
  width: 304px;
  .header-content {
    box-sizing: border-box;
    min-width: 180px;
    height: 35px;
    border-bottom: 1px solid #f1f3f6;
    display: flex;
    justify-content: center;

    .header-item {
      position: relative;
      width: 70px;
      height: 100%;
      text-align: center;
      color: rgba(#3d465a, 0.8);
      font-size: 14px;
      line-height: 34px;
      cursor: pointer;
      margin-right: 20px;

      &:last-child {
        margin-right: 0;
      }

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: #1991fb;
        opacity: 0;
      }

      &.is-active {
        color: #1991fb;

        &::after {
          opacity: 1;
        }
      }

      &.is-disabled {
        color: rgba(#3d465a, 0.5);
        cursor: not-allowed;
      }
    }
  }

  .container {
    .empty-content {
      padding: 15px 20px 38.75px;
    }
  }
}
</style>
